import { queryOptions } from '@tanstack/react-query';
import type { AdminMeetingTemplateDto } from '@upme/contracts';
import { api } from '../../app/api-client';

export const meetingTemplatesKey = ['admin', 'meeting-templates'] as const;

export const listMeetingTemplatesOptions = () =>
  queryOptions({
    queryKey: [...meetingTemplatesKey],
    queryFn: () => api.get('admin/meeting-templates').json<AdminMeetingTemplateDto[]>(),
    staleTime: 30_000,
  });

export const meetingTemplateByIdOptions = (id: string) =>
  queryOptions({
    queryKey: [...meetingTemplatesKey, id],
    queryFn: () => api.get(`admin/meeting-templates/${id}`).json<AdminMeetingTemplateDto>(),
  });
